module.exports = __webpack_public_path__ + "img/2.5caf4156.jpg";